import React from 'react';

export const BrandLogo = ({ size = 48, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ filter: 'drop-shadow(0 4px 8px rgba(251, 191, 36, 0.45))', overflow: 'visible', display: 'inline-block' }}
    >
      <defs>
        <linearGradient id="gold-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE07D" />
          <stop offset="50%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#92400E" />
        </linearGradient>
        <linearGradient id="silver-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="50%" stopColor="#cbd5e1" />
          <stop offset="100%" stopColor="#475569" />
        </linearGradient>
      </defs>

      {/* Golden Crown */}
      <path 
        d="M 15 25 L 32 42 L 50 15 L 68 42 L 85 25 L 80 62 L 20 62 Z" 
        fill="url(#gold-grad)" 
        stroke="#78350f" 
        strokeWidth="2.5" 
        strokeLinejoin="round" 
      />

      {/* Left Die (White) */}
      <rect 
        x="20" 
        y="50" 
        width="26" 
        height="26" 
        rx="6" 
        fill="#ffffff" 
        stroke="#475569" 
        strokeWidth="2.5" 
        transform="rotate(-10 33 63)" 
        style={{ filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.4))' }}
      />
      
      {/* Right Die (Gold) */}
      <rect 
        x="54" 
        y="46" 
        width="26" 
        height="26" 
        rx="6" 
        fill="url(#gold-grad)" 
        stroke="#78350f" 
        strokeWidth="2.5" 
        transform="rotate(15 67 59)" 
        style={{ filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.4))' }}
      />

      {/* Dots on Left Die (Rotated) */}
      <circle cx="27" cy="58" r="3" fill="#1e293b" />
      <circle cx="39" cy="70" r="3" fill="#1e293b" />

      {/* Dots on Right Die (Rotated) */}
      <circle cx="62" cy="53" r="3" fill="#ffffff" stroke="#78350f" strokeWidth="0.5" />
      <circle cx="70" cy="61" r="3" fill="#ffffff" stroke="#78350f" strokeWidth="0.5" />
      <circle cx="66" cy="57" r="3" fill="#ffffff" stroke="#78350f" strokeWidth="0.5" />
    </svg>
  );
};
